/**
 * Created by neo on 20.01.21.
 */

export type MediaTextTrack = {
  title: string;
  language: string;
  url: string;
  index: number;
  mimeType: string;
};

/** @deprecated Use raw object instead */
export function createMediaTextTrack(json?: Partial<MediaTextTrack>): MediaTextTrack {
  return {
    title: json?.title ?? '',
    language: json?.language ?? '',
    url: json?.url ?? '',
    index: json?.index ?? 0,
    mimeType: json?.mimeType ?? '',
  };
}
